module.exports = __webpack_public_path__ + "media/images/top-10-edfbf6af67467d497a0b2c0242e56543.png";